<template>
  <div
    v-if="isVisible"
    class="fixed inset-0 z-10 overflow-y-auto"
  >
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        @click="closeModal"
      />
      <div
        aria-modal="true"
        class="inline-block align-bottom bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full"
        :class="maxWidth"
        role="dialog"
      >
        <slot name="header" />
        <slot name="body">
          <p class="text-sm text-gray-500">
            Custom modal content goes here.
          </p>
        </slot>
        <slot name="footer">
          <button
            class="mt-3 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:mt-0 sm:w-auto sm:text-sm"
            type="button"
            @click="closeModal"
          >
            Close
          </button>
        </slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: "Modal",
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    maxWidth: {
      type: String,
      default: 'sm:max-w-lg'
    },
  },
  emits: ['update:isVisible'],
  methods: {
    closeModal() {
      this.$emit('update:isVisible', false);
    }
  }
});
</script>
